import * as React from 'react';
import { Text, Flex } from "./..";
import { PaginationButtonWrapper, PaginationButton } from './BaseToggleGroup';
export var PageSizeSelector = function (_a) {
    var _b = _a.pageSize, pageSize = _b === void 0 ? 20 : _b, _c = _a.pageSizes, pageSizes = _c === void 0 ? [10, 20, 50] : _c, onChangeFromProps = _a.onChange, id = _a.id;
    return (React.createElement(Flex, { lss: {
            alignItems: 'center'
        } },
        React.createElement(Text, { as: "p", lss: {
                textScale: 'caption',
                mr: 'sm'
            } }, "Rows Per Page:"),
        React.createElement(PaginationButtonWrapper, null, pageSizes.map(function (item) { return (React.createElement(PaginationButton, { id: id ? id + "-page-size-" + item : undefined, key: "page-size-" + item, emphasis: "low", scale: "sm", value: item, isActive: item === pageSize, onClick: function () {
                if (onChangeFromProps) {
                    onChangeFromProps({ pageSize: item });
                }
            }, "aria-label": "Change page size to " + item }, item)); }))));
};
//# sourceMappingURL=PageSizeSelector.js.map